import { Switch } from '@mui/material';
import styled from 'styled-components';

export const StyledSwitch = styled(Switch)(
  ({ theme }) => `
    height: auto !important;
    .MuiSwitch-switchBase {
      top: 12px;
      left: 12px;
      border: 1px solid ${theme.uptimeColors.grayScales.darkerGray};
      padding: 0px !important;
    }
    .MuiSwitch-switchBase.Mui-checked {
      transform: translateX(16px);
    }
    .MuiSwitch-thumb {
      width: 14px;
      height: 14px;
    }
    .MuiSwitch-track {
      background-color: ${theme.uptimeColors.grayScales.darkGray};
      width: 32px;
      height: 16px;
      border-radius: 8px;
    }
    .MuiSwitch-colorSecondary.Mui-checked {
      color: ${theme.uptimeColors.grayScales.white};
      border: 1px solid ${theme.uptimeColors.mainTheme.primary};
    }
    .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track {
      background-color: ${theme.uptimeColors.mainTheme.primary};
      opacity: 1;
    }
  `
)